import { create } from 'zustand';

type PropertyTab = 'style' | 'data' | 'palette';
type ActivePanel = 'properties' | 'comments' | 'diagram-settings' | 'diagram-history' | 'used-in' | 'assistant-insights' | null;

interface UIState {
  propertyPanelOpen: boolean;
  propertyPanelTab: PropertyTab;
  isPanMode: boolean;
  propertyPanelUserClosed: boolean;
  activePanel: ActivePanel;
  alignmentGuidesEnabled: boolean;
  alignmentGuidesSnapEnabled: boolean;
  distributionGuidesEnabled: boolean;
  distributionGuidesSnapEnabled: boolean;
  setPropertyPanelOpen: (open: boolean) => void;
  setPropertyPanelTab: (tab: PropertyTab) => void;
  setPropertyPanelUserClosed: (closed: boolean) => void;
  setPanMode: (on: boolean) => void;
  setActivePanel: (panel: ActivePanel) => void;
  setAlignmentGuidesEnabled: (on: boolean) => void;
  setAlignmentGuidesSnapEnabled: (on: boolean) => void;
  setDistributionGuidesEnabled: (on: boolean) => void;
  setDistributionGuidesSnapEnabled: (on: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  propertyPanelOpen: true,
  propertyPanelTab: 'data',
  isPanMode: false,
  propertyPanelUserClosed: false,
  activePanel: 'properties',
  alignmentGuidesEnabled: true,
  alignmentGuidesSnapEnabled: true,
  distributionGuidesEnabled: true,
  distributionGuidesSnapEnabled: true,
  setPropertyPanelOpen: (open) => set({ propertyPanelOpen: open }),
  setPropertyPanelTab: (tab) => set({ propertyPanelTab: tab }),
  setPropertyPanelUserClosed: (closed) => set({ propertyPanelUserClosed: closed }),
  setPanMode: (on) => set({ isPanMode: on }),
  setActivePanel: (panel) => set({ activePanel: panel }),
  setAlignmentGuidesEnabled: (on) => set({ alignmentGuidesEnabled: on }),
  setAlignmentGuidesSnapEnabled: (on) => set({ alignmentGuidesSnapEnabled: on }),
  setDistributionGuidesEnabled: (on) => set({ distributionGuidesEnabled: on }),
  setDistributionGuidesSnapEnabled: (on) => set({ distributionGuidesSnapEnabled: on }),
}));

